export default "__VITE_ASSET__CKdCkgNz__"